'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _destinationParser = require('../helpers/destination-parser');

var _ChildrenOptions = require('./ChildrenOptions');

var _ChildrenOptions2 = _interopRequireDefault(_ChildrenOptions);

var _Suggest = require('./Suggest');

var _Suggest2 = _interopRequireDefault(_Suggest);

var _Period = require('./Period');

var _Period2 = _interopRequireDefault(_Period);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchBox = function (_Component) {
  (0, _inherits3.default)(SearchBox, _Component);

  function SearchBox(props) {
    (0, _classCallCheck3.default)(this, SearchBox);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchBox.__proto__ || (0, _getPrototypeOf2.default)(SearchBox)).call(this, props));

    _moment2.default.locale(props.lang);
    _this.onChangeValue = _this.onChangeValue.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(SearchBox, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        // this is only for CSS on mobile
        hideDetails: this.props.hideDetails
      });
    }
  }, {
    key: 'onChangeValue',
    value: function onChangeValue() {
      var values = (0, _extends3.default)({}, this.props.values);

      for (var _len = arguments.length, targets = Array(_len), _key = 0; _key < _len; _key++) {
        targets[_key] = arguments[_key];
      }

      targets.filter(function (target) {
        return target;
      }).map(function (target) {
        values[target.name] = target.value;
        return values;
      });
      this.props.onChange(values);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          lang = _props.lang,
          hasDestination = _props.hasDestination,
          destination = _props.destination,
          i18n = _props.i18n,
          submitText = _props.submitText,
          _onSubmit = _props.onSubmit,
          errors = _props.errors,
          focusedField = _props.focusedField,
          setFocusedField = _props.setFocusedField,
          isMobile = _props.isMobile,
          isLoading = _props.isLoading,
          display = _props.display,
          setSearchBoxDisplay = _props.setSearchBoxDisplay,
          values = _props.values;
      var hideDetails = this.state.hideDetails;

      var destinationError = _lodash2.default.find(errors, { fields: 'destination' });
      var checkinError = _lodash2.default.find(errors, { fields: 'checkin' });
      var checkoutError = _lodash2.default.find(errors, { fields: 'checkout' });

      // XXX: move to container
      var rooms = Number(values.rooms);
      var adults = Number(values.adults);
      var children = Number(values.children);
      var roomConditionText = rooms > 1 ? i18n.searchForm.numOfRooms.replace(/\{room\}/, rooms) : i18n.searchForm.numOfRoom.replace(/\{room\}/, rooms);
      if (adults || children) {
        roomConditionText = roomConditionText.concat(' x');
        if (adults) {
          roomConditionText = roomConditionText.concat(' ' + (adults > 1 ? i18n.searchForm.numOfAdults.replace(/\{adult\}/, adults) : i18n.searchForm.numOfAdult.replace(/\{adult\}/, adults)));
        }
        if (children) {
          roomConditionText = roomConditionText.concat(' ' + (children > 1 ? i18n.searchForm.numOfChildren.replace(/\{child\}/, children) : i18n.searchForm.numOfChild.replace(/\{child\}/, children)));
        }
      }

      return _react2.default.createElement(
        'div',
        { id: 'searchbar', className: hideDetails ? 'hide-details' : 'show-details' },
        _react2.default.createElement(
          'div',
          { className: 'searchbar-inner' },
          display === 'form' ? _react2.default.createElement(
            'form',
            {
              onSubmit: function onSubmit(evt) {
                evt.preventDefault();
                // XXX: For RoomSearchBox we don't have to check destination
                var suggestKey = _this2.suggest ? _this2.suggest.getSuggestKey() : '';
                // XXX: workaround for the submit with Enter key problem
                //      need to refactor
                var destination = suggestKey || _this2.props.values.destination;
                if (destination) {
                  _onSubmit((0, _extends3.default)({}, _this2.props.values, {
                    adults: _this2.props.values.adults || 2,
                    destination: (0, _destinationParser.hyphenize)(destination)
                  }));
                } else {
                  _this2.props.setSearchErrors([{
                    code: 'param_invalid',
                    fields: 'destination',
                    message: i18n.errors.destinationNotFound
                  }]);
                }
              }
            },
            hasDestination ? _react2.default.createElement(
              'div',
              { className: 'searchform-location' },
              _react2.default.createElement(
                'label',
                {
                  className: 'searchform-label',
                  htmlFor: 'destination',
                  onFocusCapture: function onFocusCapture(e) {
                    // XXX: on mobile when the entire search box is opened for the 1st time,
                    //      we need to stop event propagation to prevent the suggest modal from blocking the DatePicker
                    if (_this2.state.hideDetails) {
                      if (isMobile) {
                        e.stopPropagation();
                      }
                      _this2.setState({ hideDetails: false });
                    }
                  }
                },
                _react2.default.createElement(_Suggest2.default, {
                  ref: function ref(node) {
                    _this2.suggest = node;
                  },
                  type: 'text',
                  name: 'destination',
                  hasError: destinationError !== undefined,
                  placeholder: i18n.searchForm.destination,
                  destination: destination,
                  onChange: function onChange(suggestion) {
                    if (destinationError !== undefined) {
                      _this2.props.clearSearchErrors();
                    }
                    _this2.onChangeValue({
                      name: 'destination',
                      value: suggestion
                    });
                  }
                })
              ),
              destinationError ? _react2.default.createElement(
                'div',
                { className: 'panel-error panel-mini' },
                _react2.default.createElement(
                  'div',
                  { className: 'panel-body' },
                  _react2.default.createElement(
                    'p',
                    null,
                    destinationError.message
                  )
                )
              ) : ''
            ) : '',
            _react2.default.createElement(_Period2.default, {
              lang: lang,
              displayFormat: i18n.format.searchboxDate,
              monthFormat: i18n.format.yearAndMonth,
              startDatePlaceholderText: i18n.searchForm.checkin,
              endDatePlaceholderText: i18n.searchForm.checkout,
              startDate: this.props.values.checkin,
              endDate: this.props.values.checkout,
              minimumNights: 1,
              disableStartDatesBefore: (0, _moment2.default)(),
              disableStartDatesAfter: (0, _moment2.default)().add(24, 'months').endOf('year').subtract(1, 'day'),
              disableEndDatesBefore: this.props.values.checkin ? (0, _moment2.default)(this.props.values.checkin, 'YYYY-MM-DD') : (0, _moment2.default)(),
              disableEndDatesAfter: (0, _moment2.default)().add(24, 'months').endOf('year'),
              onStartDateChange: function onStartDateChange(checkin) {
                var checkout = (0, _moment2.default)(checkin, 'YYYY-MM-DD').isSameOrAfter((0, _moment2.default)(_this2.props.values.checkout, 'YYYY-MM-DD')) ? '' : _this2.props.values.checkout;
                _this2.onChangeValue({
                  name: 'checkin',
                  value: checkin
                }, {
                  name: 'checkout',
                  value: checkout
                });
              },
              onEndDateChange: function onEndDateChange(checkout) {
                var checkin = _this2.props.values.checkin;
                _this2.onChangeValue({
                  name: 'checkin',
                  value: checkin
                }, {
                  name: 'checkout',
                  value: checkout
                });
              },
              startDateError: checkinError,
              endDateError: checkoutError,
              focusedInput: focusedField.hotelInfoCheckin ? 'startDate' : focusedField.hotelInfoCheckout ? 'endDate' : null,
              onFocusChange: function onFocusChange(focusedInput) {
                // XXX: perhaps we should set the focusedField according to the focusedInput,
                //      but it'll create redundant prop changes...
                //      there's no side effect for ignoring the focusedInput changes for 'startDate' and 'endDate'
                if (!focusedInput && setFocusedField) {
                  setFocusedField({
                    hotelInfoCheckin: false,
                    hotelInfoCheckout: false
                  });
                }
              }
            }),
            _react2.default.createElement(
              'div',
              { className: 'searchform-rooms' },
              _react2.default.createElement(
                'label',
                { htmlFor: 'rooms-input', className: 'searchform-label' },
                _react2.default.createElement(
                  'span',
                  { className: 'for-reader' },
                  i18n.searchForm.rooms
                ),
                _react2.default.createElement(
                  'select',
                  {
                    id: 'rooms-input',
                    className: 'rooms-input',
                    name: 'rooms',
                    value: this.props.values.rooms,
                    onChange: function onChange(evt) {
                      return _this2.onChangeValue(evt.target);
                    }
                  },
                  _react2.default.createElement(
                    'option',
                    { value: 1 },
                    i18n.searchForm.numOfRoom.replace(/\{room\}/, 1)
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 2 },
                    i18n.searchForm.numOfRooms.replace(/\{room\}/, 2)
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 3 },
                    i18n.searchForm.numOfRooms.replace(/\{room\}/, 3)
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 4 },
                    i18n.searchForm.numOfRooms.replace(/\{room\}/, 4)
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 5 },
                    i18n.searchForm.numOfRooms.replace(/\{room\}/, 5)
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 6 },
                    i18n.searchForm.numOfRooms.replace(/\{room\}/, 6)
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 7 },
                    i18n.searchForm.numOfRooms.replace(/\{room\}/, 7)
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 8 },
                    i18n.searchForm.numOfRooms.replace(/\{room\}/, 8)
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 9 },
                    i18n.searchForm.numOfRooms.replace(/\{room\}/, 9)
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 10 },
                    i18n.searchForm.numOfRooms.replace(/\{room\}/, 10)
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'searchform-adults' },
              _react2.default.createElement(
                'label',
                { htmlFor: 'adults-input', className: 'searchform-label' },
                _react2.default.createElement(
                  'span',
                  { className: 'for-reader' },
                  i18n.searchForm.adults
                ),
                _react2.default.createElement(
                  'select',
                  {
                    id: 'adults-input',
                    className: 'adults-input',
                    name: 'adults',
                    value: this.props.values.adults || 2,
                    onChange: function onChange(evt) {
                      return _this2.onChangeValue(evt.target);
                    }
                  },
                  _react2.default.createElement(
                    'option',
                    { value: 1 },
                    i18n.searchForm.numOfAdult.replace(/\{adult\}/, 1)
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 2 },
                    i18n.searchForm.numOfAdults.replace(/\{adult\}/, 2)
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 3 },
                    i18n.searchForm.numOfAdults.replace(/\{adult\}/, 3)
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 4 },
                    i18n.searchForm.numOfAdults.replace(/\{adult\}/, 4)
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 5 },
                    i18n.searchForm.numOfAdults.replace(/\{adult\}/, 5)
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 6 },
                    i18n.searchForm.numOfAdults.replace(/\{adult\}/, 6)
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 7 },
                    i18n.searchForm.numOfAdults.replace(/\{adult\}/, 7)
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 8 },
                    i18n.searchForm.numOfAdults.replace(/\{adult\}/, 8)
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 9 },
                    i18n.searchForm.numOfAdults.replace(/\{adult\}/, 9)
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 10 },
                    i18n.searchForm.numOfAdults.replace(/\{adult\}/, 10)
                  )
                )
              )
            ),
            _react2.default.createElement(_ChildrenOptions2.default, {
              name: 'childrenOptions',
              i18n: i18n,
              isMobile: isMobile,
              child: this.props.values.children,
              childrenOptions: this.props.values.childrenOptions,
              onChange: function onChange(value, childrenOptions) {
                return _this2.onChangeValue({
                  name: 'children',
                  value: value
                }, {
                  name: 'childrenOptions',
                  value: childrenOptions
                });
              }
            }),
            _react2.default.createElement(
              'div',
              { className: 'searchform-submit' },
              _react2.default.createElement(
                'button',
                {
                  type: 'submit',
                  className: 'btn-submit' + (isLoading ? ' progress-button' : '')
                },
                _react2.default.createElement(
                  'span',
                  null,
                  submitText
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'loader' },
                  _react2.default.createElement(
                    'svg',
                    { className: 'circular', viewBox: '25 25 50 50' },
                    _react2.default.createElement('circle', { className: 'path', cx: '50', cy: '50', fill: 'none', r: '20', strokeWidth: '2' })
                  )
                )
              )
            )
          ) : display === 'text' ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'search-condition-text' },
              destination ? _react2.default.createElement(
                'span',
                { className: 'condtion-destination' },
                destination
              ) : null,
              this.props.values.checkin && this.props.values.checkout ? _react2.default.createElement(
                'span',
                { className: 'condtion-dates' },
                i18n.searchForm.period.replace(/\{checkin\}/, (0, _moment2.default)(this.props.values.checkin, 'YYYY-MM-DD').format(i18n.format.searchboxTextDate)).replace(/\{checkout\}/, (0, _moment2.default)(this.props.values.checkout, 'YYYY-MM-DD').format(i18n.format.searchboxTextDate))
              ) : null,
              _react2.default.createElement(
                'span',
                { className: 'condtion-rooms' },
                roomConditionText
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'searchform-submit change-button' },
              _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  className: 'btn-submit' + (isLoading ? ' progress-button' : ''),
                  onClick: function onClick() {
                    return setSearchBoxDisplay('form');
                  }
                },
                _react2.default.createElement(
                  'span',
                  null,
                  i18n.searchForm.change
                )
              )
            )
          ) : null
        )
      );
    }
  }]);
  return SearchBox;
}(_react.Component);

SearchBox.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  lang: _react.PropTypes.string.isRequired,
  display: _react.PropTypes.oneOf(['text', 'form']),
  hideDetails: _react.PropTypes.bool,
  // if the destination input should be displayed
  hasDestination: _react.PropTypes.bool.isRequired,
  // the destination text to be displayed
  destination: _react.PropTypes.string,
  onSubmit: _react.PropTypes.func.isRequired,
  onChange: _react.PropTypes.func.isRequired,
  values: _react.PropTypes.object,
  submitText: _react.PropTypes.string,
  errors: _react.PropTypes.array,
  isMobile: _react.PropTypes.bool,
  isLoading: _react.PropTypes.bool,
  focusedField: _react.PropTypes.object,
  setFocusedField: _react.PropTypes.func,
  setSearchErrors: _react.PropTypes.func,
  clearSearchErrors: _react.PropTypes.func,
  setSearchBoxDisplay: _react.PropTypes.func
};

SearchBox.defaultProps = {
  display: 'form',
  hideDetails: false,
  hasDestination: true,
  submitText: 'Search',
  values: {
    destination: '',
    checkin: '',
    checkout: '',
    rooms: '1',
    adults: '2',
    children: '0'
  },
  errors: [],
  isLoading: false,
  focusedField: {}
};

exports.default = SearchBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchBox.js
// module id = 580
// module chunks = 0